import React, { useState, useRef} from 'react';
import {Tooltip, Overlay} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faHourglassHalf, faTimes } from '@fortawesome/pro-solid-svg-icons'


function SyncTooltip({messages, target, show}) {
  return (
  <Overlay target={target.current} show={show} placement="bottom">
    {(props) => (
      <Tooltip {...props}>
        {
          messages.map((m, i) => {return (< React.Fragment key={i}>{m} <br/></React.Fragment>)})
        }
      </Tooltip>
    )}
  </Overlay>
  )
}

export function SyncStatus({ status, errors }) {
  const target = useRef(null);
  const [show, setShow] = useState(false);
  if (status == "pending") {
    return ( <FontAwesomeIcon icon={faHourglassHalf} /> )
  }
  if (status == "ok") {
    return ( <FontAwesomeIcon icon={faCheck} /> )
  }
  if (status == "ko") {
    return (
      <>
        <FontAwesomeIcon icon={faTimes}  ref={target} onMouseOver={() => setShow(true)} onMouseOut={() => setShow(false)} />
        <SyncTooltip target={target} messages={errors} show={show} />
      </>
    )
  }
}